var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Info',[_c('div',[_vm._v("Seerist: "+_vm._s(_vm.message))]),_c('div',[_c('a',{attrs:{"href":"/login"}},[_vm._v("Login")])])])}
var staticRenderFns = []

export { render, staticRenderFns }